import * as React from "react";
import { IdOrientation } from "../../../constants/IdOrientation";
import { IdStyles } from "../../../less/IdStyles";
import { IdTooltipAnchor, TooltipText } from "../../tooltip";
import { IdIcon } from "./IdIcon";
import { InnerIcon } from "./InnerIcon";
export var Icon = function (_a) {
    var icon = _a.icon, styleId = _a.styleId, children = _a.children, tooltipLoca = _a.tooltipLoca, _b = _a.orientation, orientation = _b === void 0 ? IdOrientation.Up : _b, _c = _a.tooltipAnchor, tooltipAnchor = _c === void 0 ? IdTooltipAnchor.Bottom : _c, tooltipVerticalAdjust = _a.tooltipVerticalAdjust, _d = _a.isLocked, isLocked = _d === void 0 ? false : _d;
    var className = "" + IdStyles.IconPlaceholderMedium;
    if (icon !== undefined || styleId !== undefined) {
        className = "" + styleId + icon;
    }
    var orientationStyle = getOrientationStyle(orientation);
    return tooltipLoca === undefined ? (React.createElement("div", { className: className, style: orientationStyle },
        React.createElement(InnerIcon, { icon: isLocked ? IdIcon.LockIcn : undefined, styleId: styleId }, children))) : (React.createElement(TooltipText, { id: tooltipLoca, anchor: tooltipAnchor, adjustVertical: tooltipVerticalAdjust },
        React.createElement("div", { className: className, style: orientationStyle },
            React.createElement(InnerIcon, { icon: isLocked ? IdIcon.LockIcn : undefined, styleId: styleId }, children))));
};
var getOrientationStyle = function (orientation) {
    switch (orientation) {
        default:
        case IdOrientation.Up:
            return {};
        case IdOrientation.Left:
            return {
                transform: "rotate(-90deg)",
            };
        case IdOrientation.Right:
            return {
                transform: "rotate(90deg)",
            };
        case IdOrientation.Down:
            return {
                transform: "rotate(180deg)",
            };
    }
};



//////////////////
// WEBPACK FOOTER
// ./src/features/generic/icon/Icon.tsx
// module id = 11
// module chunks = 3